import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material"
import { useChanegPasswordsMutation } from "../../features/Auth/authApi"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toast } from "react-toastify"
import { Visibility, VisibilityOff } from "@mui/icons-material"
// import { useNavigate } from "react-router-dom"
type Props = {
  opens: boolean
  handleClose: () => void
}

interface ChangePasswordsProps {
  name: string
  password: string
  newPassword: string
}

interface PasswordState {
  password1: boolean
  password2: boolean
  password3: boolean
}
export default function ChangePasswordModal({ opens, handleClose }: Props) {
  const [
    changePasswords,
    { data: changeData, error: changeError, isLoading: changeIsLoading },
  ] = useChanegPasswordsMutation()

  // const navigate = useNavigate()
  
  const [showPasswords, setShowPasswords] = useState<PasswordState>({
    password1: false,
    password2: false,
    password3: false,
  })

  const onSubmit = (data: any) => {
    const payload = {
      password: data?.name,
      newPassword: data?.password,
    }

    changePasswords(payload)
  }

  const schemaResolver = yup.object().shape({
    name: yup.string().label("Old Password").required(),
    password: yup
      .string()
        .required("Please Fill In A Password")
        .test(
          "Password-Length",
          "Password Must Be 8 Characters Or More",
          (value: any) => value && (value as any).length >= 8,
        )
        .test(
          "Password-Strength",
          "Include At Least One Uppercase Letter, One Lowercase Letter, One Number, And One Special Character",
          (value) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~^])[A-Za-z\d@$!%*#?&~^]{8,}$/.test(
              value || "",
            ),
        ),
    newPassword: yup
      .string()
      .label("Confirm Password")
      .required()
      .oneOf([yup.ref("password"), ""], "Passwords Not Match"),
  })

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<ChangePasswordsProps, any>({
    resolver: yupResolver(schemaResolver),
  })

  useEffect(() => {
    if (changeData?.message) {
      toast.success(changeData?.message)
      handleClose()
      setValue("name", "")
      setValue("password", "")
      setValue("newPassword", "")
    } else if ((changeError as any)?.data?.message) {
      toast.error((changeError as any)?.data?.message)
    }
  }, [changeData, changeError])

  const emptyValue = () => {
    handleClose()
    setValue("name", "")
    setValue("password", "")
    setValue("newPassword", "")
    reset()
  }

  const toggleShowPassword = (key: any) => {
    setShowPasswords((prevState: any) => ({
      ...prevState,
      [key]: !prevState[key] as any,
    }))
  }
  return (
    <>
      <Dialog
        open={opens}
        onClose={(!changeIsLoading as any) && emptyValue}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          className="text-center"
          style={{
            fontSize: "20px",
            fontFamily: "Montserrat",
            color: "#F475A4",
          }}
        >
          Change Password
        </DialogTitle>
        <DialogContent>
          <Box className="mb-4 position-relative">
            <label
              className="field-label d-block"
              style={{
                fontSize: "16px",
                fontFamily: "Montserrat",
                color: "#000",
              }}
            >
              Old Password
            </label>
            <input
              type={showPasswords.password1 ? "text" : "password"}
              placeholder="Enter Old Password"
              className="form-field"
              {...register("name")}
              style={{
                width: "100%",
                fontSize: "18px",
                fontFamily: "Montserrat",
                fontWeight: "400",
                border: "1px solid #C1C1C1",
                borderRadius: "11px",
                lineHeight: "22px",
                backgroundColor: "transparent",
                padding: "11px 40px 11px 11px", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
            <IconButton
              onClick={() => toggleShowPassword("password1")}
              edge="end"
              style={{
                position: "absolute",
                right: "18px",
                top: "46px",
                transform: "translateY(-50%)",
              }}
            >
              {showPasswords.password1 ? <Visibility /> : <VisibilityOff />}
            </IconButton>
            <span className="text-danger">{errors?.name?.message}</span>
          </Box>
          <Box className="mb-4 position-relative">
            <label
              className="field-label d-block"
              style={{
                fontSize: "16px",
                fontFamily: "Montserrat",
                color: "#000",
              }}
            >
              New Password
            </label>
            <input
              type={showPasswords.password2 ? "text" : "password"}
              placeholder="Enter New Password"
              className="form-field"
              {...register("password")}
              style={{
                width: "100%",
                fontSize: "18px",
                fontFamily: "Montserrat",
                fontWeight: "400",
                border: "1px solid #C1C1C1",
                borderRadius: "11px",
                lineHeight: "22px",
                backgroundColor: "transparent",
                padding: "11px 40px 11px 11px", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
            <IconButton
              onClick={() => toggleShowPassword("password2")}
              edge="end"
              style={{
                position: "absolute",
                right: "18px",
                top: "46px",
                transform: "translateY(-50%)",
              }}
            >
              {showPasswords.password2 ? <Visibility /> : <VisibilityOff />}
            </IconButton>
            <span className="text-danger">{errors?.password?.message}</span>
          </Box>
          <Box className="position-relative">
            <label
              className="field-label d-block"
              style={{
                fontSize: "16px",
                fontFamily: "Montserrat",
                color: "#000",
              }}
            >
              Confirm Password
            </label>
            <input
              type={showPasswords.password3 ? "text" : "password"}
              placeholder="Enter Confirm Password"
              className="form-field"
              {...register("newPassword")}
              style={{
                width: "100%",
                fontSize: "18px",
                fontFamily: "Montserrat",
                fontWeight: "400",
                border: "1px solid #C1C1C1",
                borderRadius: "11px",
                lineHeight: "22px",
                backgroundColor: "transparent",
                padding: "11px 40px 11px 11px", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
            <IconButton
              onClick={() => toggleShowPassword("password3")}
              edge="end"
              style={{
                position: "absolute",
                right: "18px",
                top: "46px",
                transform: "translateY(-50%)",
              }}
            >
              {showPasswords.password3 ? <Visibility /> : <VisibilityOff />}
            </IconButton>
            <span className="text-danger">{errors?.newPassword?.message}</span>
          </Box>
        </DialogContent>
        <Box pb={2}>
        <DialogActions className="justify-content-between px-4"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}>
            <Button
              onClick={handleSubmit(onSubmit)}
              style={{
                border: "1px solid #F475A4",
                borderRadius: "8px",
                background: "#F475A4",
                fontSize: "16px",
                fontFamily: "Montserrat",
                color: "#fff",
                textTransform: "capitalize",
                padding: "7px 28px",
                width: "206px",
              }}
            >
              {changeIsLoading ? (
                <Typography fontSize={1}>
                  <CircularProgress
                    style={{ color: "pink", fontSize: 25 }}
                    size={25}
                  />
                </Typography>
              ) : (
                "Change Password"
              )}
            </Button>
            <Button
              onClick={emptyValue}
              style={{
                border: "1px solid #BFBFBF",
                borderRadius: "8px",
                background: "#fff",
                fontSize: "16px",
                fontFamily: "Montserrat",
                color: "#A0A0A0",
                textTransform: "capitalize",
                padding: "7px 28px",
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}
